import { PayoutStatusLabel } from '@/components/modules/Payouts/PayoutsList/components/PayoutStatusLabel';
import { PayoutsListRowProps } from '@/components/modules/Payouts/PayoutsList/types/PayoutsListRowProps';
import { Text } from '@/components/shared/components/Text';

export const statusFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.5,
    field: 'payout_status',
    headerName: <Text tId={'STATUS'} />,
    renderCell: (rowData: PayoutsListRowProps) => (
      <div style={{ minWidth: '100px', display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            minWidth: '120px',
            whiteSpace: 'break-spaces',
            lineHeight: 1.43,
          }}
        >
          <PayoutStatusLabel payoutStatus={rowData.row.status} />
        </div>
      </div>
    ),
  };
};
